/* 🤖 this file was generated by svg-to-ts */
export const matIconScheduleSend: {
  name: 'schedule-send';
  data: string;
} = {
  name: 'schedule-send',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L16.5 17.2V14h1v2.79l1.85 1.85-.7.71z"/><path d="m11 12-6-1.5V7.01l8.87 3.74c.94-.47 2-.75 3.13-.75.1 0 .19.01.28.01L3 4v16l7-2.95V17c0-.8.14-1.56.39-2.28L5 16.99V13.5l6-1.5z"/></svg>`
};
